import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomProductsService } from '../custom-products.service';
import { DateRangePickerComponent, IDateRange, IDateRangePickerOptions } from 'ngx-daterange';
import { NgSelectComponent } from '@ng-select/ng-select';
import moment from 'moment';
import { DatePipe, NgIf, NgStyle, NgFor, UpperCasePipe } from '@angular/common';
import { UntypedFormControl, UntypedFormGroup, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmBidModalComponent } from 'src/app/shared/components/confirm-bid-modal/confirm-bid-modal.component';
import { ModalConfig } from 'src/app/core/model/modal.config-model';
import { SubmitQuoteModel } from 'src/app/core/model/submit-quote-model';
import { CustomLoginService } from 'src/app/modules/custom-login/custom-login-form/custom-login.service';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { TwoDigitDecimaNumberDirective, CopyDirective, allowPositiveAndNegativeNumbersDirective } from '../../../../shared/components/two-digit-decima-number.directive';
import { ConfirmBidModalComponent as ConfirmBidModalComponent_1 } from '../../../../shared/components/confirm-bid-modal/confirm-bid-modal.component';
import { I18nModule } from '@spartacus/core';

@Component({
    selector: 'app-list-card',
    templateUrl: './list-card.component.html',
    styleUrls: ['./list-card.component.scss'],
    imports: [NgIf, NgStyle, NgFor, FormsModule, TwoDigitDecimaNumberDirective, CopyDirective, allowPositiveAndNegativeNumbersDirective, ConfirmBidModalComponent_1, UpperCasePipe, I18nModule]
})
export class ListCardComponent implements OnInit {
  @ViewChild('modalData') private modalComponent: ConfirmBidModalComponent;
  public modalConfig: ModalConfig;
  submitQuoteModel = new SubmitQuoteModel();
  @Input() port: any;
  @Input() productInfo: any;
  quality = [];
  showPart1 = true;
  @Input() browseType: any;
  quantityRangeArrya = [];
  modal = false;
  closeResult = '';
  biddingTerms = '';
  quantitySelected: any;
  actualQuantitySelected:any;
  showquantity = false;
  productPrice: any;
  @ViewChild('dateRangePicker', { static: true })
  dateRangePicker: DateRangePickerComponent;
  form: UntypedFormGroup = null;
  myGroup: UntypedFormGroup;
  startDate: any = null;
  endDate: any = null;
  datePipe = new DatePipe('en-US');
  minQty:number;
  maxQty:number;
  maxLen:number;

  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;
  firstFieldEmittedValue: IDateRange;
  secondFieldOptions: IDateRangePickerOptions = {
    clickOutsideAllowed: false,
    format: 'DD/MM/YYYY',
    icons: 'font-awesome',
    singleCalendar: true,
    minDate: moment().subtract(10, 'years'),
    maxDate: moment().add(1, 'year'),
  };
  qualitylength: any;
  isCustomerEmulated: boolean;
  writeAccess: any;
  isPlaceBidDisabled: boolean;
  qtyEmptyErr: boolean;
  qtyValidErr: boolean;
  constructor(private customProductService: CustomProductsService,
              private cd: ChangeDetectorRef,
              private customloginservice:CustomLoginService,private csAgentAuthService:CsAgentAuthService) { }

  omitSpecialChar(event): any {
    const k = event.charCode;
    return this.isValidLetter(k);
  }

  isValidLetter(k): any {
    return ((k >= 48 && k <= 57));
  }

  ngOnInit(): void {
    this.customloginservice.getASMAcess().subscribe(res=>{
      this.writeAccess = res?.writeAccess;
      this.csAgentAuthService.isCustomerEmulated().subscribe(emulated => {
        this.isCustomerEmulated = emulated;
        if(this.writeAccess==false&& this.isCustomerEmulated == true){
          this.isPlaceBidDisabled = true;
        }else{
          this.isPlaceBidDisabled = false;
        }
      })
    })
    this.form = new UntypedFormGroup({
      secondDateRange: new UntypedFormControl()
    });

    this.myGroup = new UntypedFormGroup({
      myGroupInput: new UntypedFormControl()
    });
    this.quantitySelected = '';
    this.minQty = this.productInfo.minimumQty;
    this.maxQty= this.productInfo.maximumQty;
    this.maxLen=this.maxQty.toString().length+1;
    // this.actualQuantitySelected = Number(this.productInfo.tradableBalance);
    // if(this.actualQuantitySelected<this.productInfo.minimumQty)
    // {
    //   this.showquantity = true;
    // }

    this.cd.detectChanges();
    // if (this.productInfo.maximumQty !== undefined) {
    //   const quantityRangeMin = this.productInfo.minimumQty;
    //   const quantityRangeMax = this.productInfo.maximumQty / quantityRangeMin;
    //   this.showPart1 = true;
    //   for (let i = 1; i <= quantityRangeMax; i++) {
    //     this.quantityRangeArrya.push(quantityRangeMin * i);
    //   }
    // }
    if (this.productInfo.features) {
      if (this.productInfo.features.entry) {
        // tslint:disable-next-line:typedef
        // tslint:disable-next-line:only-arrow-functions
        this.productInfo.features.entry.sort(function(a, b) {
          const textA = a.key;
          const textB = b.key;
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

      }

    }

    this.productPrice = this.productInfo.price !== undefined ? this.productInfo.price.value : '';
  }

  homeLinkClick(value): any {
    this.customProductService.getHomeLinkActive(value);
  }

  onRangeSelected(value: IDateRange): void {
    this.firstFieldEmittedValue = value;
    this.startDate = this.firstFieldEmittedValue.start.toDate();
    this.endDate = this.firstFieldEmittedValue.end.toDate();
  }
  // tslint:disable-next-line:typedef
  async openModal(content?: any, data?: any) {
    let qtyCheck;
    qtyCheck = this.checkQtyValidation();
    if(qtyCheck===false){
    if (this.browseType === 'port') {
      data.portName = this.port.name;
    } else if (this.browseType === 'browseAll') {
      if (data.ports.length > 0){
        data.portName = data.ports[0].name;
      }else{
        data.portName = '';
      }

    } else if (this.browseType === 'productType'){
      if (data.ports.length > 0){
        data.portName = data.ports[0].name;
      }else{
        data.portName = '';
      }
    }
    // if (data.maximumQty !== undefined && data.minimumQty !== undefined) {
    //   data.maximumQty = data.maximumQty;
    //   data.minimumQty = data.minimumQty;
    // }
    data.priceValue = this.productPrice;
    data.quantitySelected = this.quantitySelected;
    data.actualQuantitySelected = this.actualQuantitySelected;
    return await this.modalComponent.open(content, data);
  }
  }
  checkPriceValidation($event){
    // tslint:disable-next-line:prefer-const
    let s = $event.target.value.split('.');
    if (s.length === 1){
      if (s[0].length >= 6) {
        $event.preventDefault();
      }
    }
  }
  validateDecimalPointPrice(e): any{
    const t = e.target.value;
    this.productInfo.priceValue = (t.indexOf('.') >= 0) ? (t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 2)) : t;
    // this.cd.detectChanges();
  }

  checkQtyValidation(){
    let priceToCheck
    //this.showquantity?priceToCheck = this.actualQuantitySelected:
    priceToCheck=this.quantitySelected;
    if(priceToCheck === null){
      this.qtyEmptyErr = true;
    }else{
      if(Number(this.minQty)<=Number(priceToCheck) && Number(this.maxQty)>=Number(priceToCheck)){
        //QTY SHOULD BE BETWEEN 2K-50K
        this.qtyValidErr = false;
      }else{
        this.qtyValidErr = true;

      }
      this.qtyEmptyErr = false;
    }
    let flag =this.qtyEmptyErr||this.qtyValidErr;
    return flag;
  }
}
